import * as React from "react";

import { FormLabel, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const Row = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

const RangeFilter = ({ heading, filterList, onChange, index, column }) => {
  const [min, setMin] = React.useState(filterList[index][0] || "");
  const [max, setMax] = React.useState(filterList[index][1] || "");

  const minChange = (event) => {
    setMin(event.target.value);
    filterList[index][0] = event.target.value;
    onChange(filterList[index], index, column);
  };

  const maxChange = (event) => {
    setMax(event.target.value);
    filterList[index][1] = event.target.value;
    onChange(filterList[index], index, column);
  };

  React.useEffect(() => {
    if (filterList[index].length === 0) {
      setMin("");
      setMax("");
      filterList[index] = [];
    }
  }, [filterList, index]);

  return (
    <div data-testid={heading + "-filter"}>
      <FormLabel>{heading}</FormLabel>
      <Row>
        <TextField
          variant="outlined"
          id="min"
          value={min}
          size="small"
          sx={{ marginRight: "10px" }}
          onChange={minChange}
          placeholder="min"
          type="number"
        />
        <TextField
          variant="outlined"
          id="max"
          value={max}
          size="small"
          onChange={maxChange}
          placeholder="max"
          type="number"
        />
      </Row>
    </div>
  );
};

export default RangeFilter;

export const MaxRangeFilter = ({ heading, filterList, onChange, index, column }) => {
  const [max, setMax] = React.useState(filterList[index][0] || "");

  const maxChange = (event) => {
    setMax(event.target.value);
    filterList[index][0] = event.target.value;
    onChange(filterList[index], index, column);
  };

  React.useEffect(() => {
    if (filterList[index].length === 0) {
      setMax("");
      filterList[index] = [];
    }
  }, [filterList, index]);

  return (
    <div data-testid={heading + "-filter"}>
      <TextField
        fullWidth
        label={heading}
        variant="standard"
        id="max"
        value={max}
        size="small"
        onChange={maxChange}
        type="number"
      />
    </div>
  );
};
